const AttendeeStatus = {
    AVAILABLE: 1,
    SCANNED: 2,
    CANCELLED: 3,
}

export default AttendeeStatus;